module.exports = __webpack_public_path__ + "static/ART-1-143cc4eda585447735be3c28bf90ea0e.jpg";